/* GPNVG-18 round 3, 14 Oct 2026: loadout selector keys, fan motion pause when off screen. No em or en dashes. */
(function () {
  "use strict";
  var root = document.getElementById("no-gpnvg18");
  if (!root || root.dataset.ng3Ready) return;
  root.dataset.ng3Ready = "true";

  // Loadout selector: the slots are the existing field of view buttons (data-gq-sw), so the main script still swaps
  // the picture and caption. Here: arrow keys move between slots and press them (roving focus, like a game hotbar).
  var bar = root.querySelector("[data-ng3-hotbar]");
  if (bar) {
    var slots = Array.from(bar.querySelectorAll("[data-gq-sw]"));
    var sync = function () { slots.forEach(function (s) { s.tabIndex = s.getAttribute("aria-pressed") === "true" ? 0 : -1; }); };
    slots.forEach(function (s, i) {
      s.addEventListener("click", function () { setTimeout(sync, 0); });
      s.addEventListener("keydown", function (e) {
        var k = e.key, j = -1;
        if (k === "ArrowRight" || k === "ArrowDown") j = (i + 1) % slots.length;
        else if (k === "ArrowLeft" || k === "ArrowUp") j = (i - 1 + slots.length) % slots.length;
        else if (k === "Home") j = 0; else if (k === "End") j = slots.length - 1;
        else if (k === "1" || k === "2" || k === "3") j = +k - 1;
        if (j < 0) return;
        e.preventDefault(); slots[j].focus(); slots[j].click();
      });
    });
    sync();
  }

  // Fan: run the pulse only while it is on screen (saves battery on phones).
  var fan = root.querySelector("[data-ng3-fan]");
  if (fan && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { fan.querySelectorAll("svg *").forEach(function (n) { n.style.animationPlayState = e.isIntersecting ? "running" : "paused"; }); });
    }, { threshold: 0.05 });
    io.observe(fan);
  }
})();
